var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F59B00",
    fillRule: "evenodd",
    d: "M15 1.5c-2.4 0-4.65.6-6.75 1.8C6.15 4.5 4.5 6.15 3.3 8.25 2.1 10.35 1.5 12.6 1.5 15c0 2.4.6 4.65 1.8 6.75 1.2 2.1 2.85 3.75 4.95 4.95 2.1 1.2 4.35 1.8 6.75 1.8 2.4 0 4.65-.6 6.75-1.8 2.1-1.2 3.75-2.85 4.95-4.95 1.2-2.1 1.8-4.35 1.8-6.75 0-2.4-.6-4.65-1.8-6.75-1.2-2.1-2.85-3.75-4.95-4.95-2.1-1.2-4.35-1.8-6.75-1.8zM15 0c2.7 0 5.2.675 7.5 2.025 2.3 1.35 4.125 3.175 5.475 5.475C29.325 9.8 30 12.3 30 15s-.675 5.2-2.025 7.5c-1.35 2.3-3.175 4.125-5.475 5.475C20.2 29.325 17.7 30 15 30s-5.2-.675-7.5-2.025C5.2 26.625 3.375 24.8 2.025 22.5.675 20.2 0 17.7 0 15s.675-5.2 2.025-7.5C3.375 5.2 5.2 3.375 7.5 2.025 9.8.675 12.3 0 15 0zm-1.2 19.8c-.2.1-.4.15-.6.15-.2 0-.375-.075-.525-.225-.15-.15-.225-.325-.225-.525s.1-.35.3-.45L16.5 15l-3.75-3.75c-.2-.1-.3-.25-.3-.45s.075-.375.225-.525c.15-.15.35-.225.6-.225s.425.05.525.15l4.2 4.2c.2.2.3.4.3.6 0 .2-.1.35-.3.45l-4.2 4.35z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoIcon);
export default __webpack_public_path__ + "static/media/go_icon.d13bf8a8fae6888d367844985fe99c97.svg";
export { ForwardRef as ReactComponent };